// component-test-check-ignore
import React from 'react';
import { Modal } from '@opendoor/bricks/complex';
import { Button, Box, Text, Flex } from '@opendoor/bricks/core';
import { ScheduleOrvaButton } from 'sellDirect/components/howItWorks/components/ScheduleOrvaButton';
import { useClosePriceAdjustment } from 'sellDirect/graphql/useClosePriceAdjustment';
import { useExperiments } from 'sellDirect/helpers/ExperimentProvider';

export interface NeutralPriceModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

/** Internal NeutralPriceModal without context */
export const NeutralPriceModalWithoutContext: React.FC<NeutralPriceModalProps> = ({
  onRequestClose,
  isOpen,
}) => {
  return (
    <Modal
      analyticsName="cake-neutral-price-modal"
      isOpen={isOpen}
      showClose
      onRequestClose={onRequestClose}
      desktopAndTabletSize="sm"
      aria-label="Updated your home info modal"
    >
      <Flex textAlign="center" flexDirection="column" alignItems="center" mx="9" mb="5">
        <Text size="s2" fontWeight="semibold">
          We need more info
        </Text>
        <Box maxWidth="347px">
          <Text size="s1" fontWeight="normal" mt="2">
            It looks like we still need some more details about your home. Set up a video
            walkthrough and show us what makes your home special.
          </Text>
          <ScheduleOrvaButton
            mt="8"
            onClick={onRequestClose}
            analyticsName="cake-neutral-price-modal-schedule-va"
          />
        </Box>
        <Button
          aria-label=""
          analyticsName="cake-neutral-price-modal-not-now"
          type="button"
          onClick={onRequestClose}
          variant="link"
          mt="6"
        >
          Not now
        </Button>
      </Flex>
    </Modal>
  );
};

/**
 * This modal is only for the Price Adjustment V2 experiment.
 *
 * Modal to show after a user has completed the price adjustment home condition flow
 * and we determined a possible adjustment of zero (0) bps.
 *
 * In this modal, we tell the customer we need more info and direct them to do a VA
 */
export const NeutralPriceModal: React.FC = () => {
  const { priceAdjustment } = useExperiments();
  const { updateClosedPriceAdjustment, isResultOpen } = useClosePriceAdjustment(
    priceAdjustment.showNeutralResult,
  );

  return (
    <NeutralPriceModalWithoutContext
      isOpen={isResultOpen}
      onRequestClose={updateClosedPriceAdjustment}
    />
  );
};
